import { Menu, Text } from '@mantine/core';
import { Icon, SymbolCodepoints } from '@uag/react-core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const Group = () => {
    const { t } = useTranslation();

    const { articleInstanceSelections, setIsGroupPanelOpen } = usePlacementStore(
        useShallow((state) => ({
            articleInstanceSelections: state.articleInstanceSelections,
            setIsGroupPanelOpen: state.setIsGroupPanelOpen
        }))
    );

    const selectedInstanceIds = useMemo(() => Object.keys(articleInstanceSelections), [articleInstanceSelections]);

    return (
        <Menu.Item
            disabled={selectedInstanceIds.length < 2}
            leftSection={
                <Icon
                    className="action-menu-entry-decoration action-menu-entry-decoration-icon"
                    icon={'stack_group' as SymbolCodepoints}
                />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right min-w-36 text-[13px]">{ShortcutAction.Group}</Text>
            }
            onClick={() => setIsGroupPanelOpen(true)}
        >
            {t('labelGroup')}
        </Menu.Item>
    );
};
